const { ga } = typeof window === 'object' ? window : {};

function track(...args) {
  // Since it can be tough to make sure GA is working right in dev environments,
  // we can make this easier using the console by disabling eslint here.
  // eslint-disable-next-line no-console
  console.info('Analytics', args);

  if (!ga) {
    return;
  }

  ga(...args);
}

/*
  Track things the user did in Google Analytics. Category and action are required. More docs:
  https://developers.google.com/analytics/devguides/collection/analyticsjs/events
  trackEvent({
    category: 'Typically the object that was interacted with',
    action: 'The type of interaction',
  })
*/
export function trackEvent({
  category, action, label, value, fieldsObject,
} = {}) {
  if (!category || !action) {
    // eslint-disable-next-line no-console
    console.error('Attempted to track an Analytics event without category/action. They are required!');
    return;
  }

  track('send', 'event', category, action, label, value, fieldsObject);
}

export function trackException(description, isFatal) {
  track('send', 'exception', { exDescription: description, exFatal: isFatal });
}



// WEBPACK FOOTER //
// ./src/util/analytics.js